import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Star, Trophy, Clock, TrendingUp, Gift, GitCompare, Check } from "lucide-react";
import { useCompare } from "../context/CompareContext";

export default function CourseResultCard({ c, showFit = true }) {
  const navigate = useNavigate();
  const { toggle, inCompare } = useCompare();
  const selected = inCompare(c.id);

  const enquire = () =>
    navigate("/", { state: { scrollTo: "contact", requestedCounsellor: `${c.course} at ${c.university}` } });

  return (
    <article className="bg-white rounded-2xl cc-shadow-card overflow-hidden group flex flex-col">
      <div className="relative h-40 overflow-hidden">
        <img src={c.image} alt={c.university} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
        {showFit && c.fit != null && (
          <div className="absolute top-3 right-3 bg-white/95 backdrop-blur rounded-xl px-3 py-1.5 flex items-center gap-1.5">
            <Star size={14} className="fill-[#F58220] text-[#F58220]" />
            <span className="font-head font-bold text-[#16244F] text-sm">{c.fit}% fit</span>
          </div>
        )}
        <div className="absolute bottom-3 left-3 bg-[#16244F]/85 text-white rounded-lg px-2.5 py-1 text-xs font-head inline-flex items-center gap-1">
          <Trophy size={12} className="text-[#F9B57C]" /> QS #{c.qs}
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="text-xs text-[#2b8cf0] font-semibold">{c.country} · {c.level}</div>
        <h3 className="font-head text-lg font-semibold text-[#16244F] mt-1 leading-snug">{c.course}</h3>
        <div className="text-sm text-[#5a6274]">{c.university}</div>

        <div className="grid grid-cols-3 gap-2 mt-4">
          <div className="rounded-lg bg-[#f6f8fc] py-2 text-center">
            <div className="font-head font-bold text-[#16244F] text-sm">₹{c.fees}L</div>
            <div className="text-[10px] text-[#8a90a0]">per yr</div>
          </div>
          <div className="rounded-lg bg-[#f6f8fc] py-2 text-center">
            <div className="font-head font-bold text-[#16244F] text-sm inline-flex items-center gap-0.5"><Clock size={11} /> {c.duration}</div>
            <div className="text-[10px] text-[#8a90a0]">duration</div>
          </div>
          <div className="rounded-lg bg-[#f6f8fc] py-2 text-center">
            <div className="font-head font-bold text-[#16a34a] text-sm inline-flex items-center gap-0.5"><TrendingUp size={11} /> {c.jobRate}%</div>
            <div className="text-[10px] text-[#8a90a0]">job rate</div>
          </div>
        </div>

        <div className="mt-3 inline-flex items-center gap-1.5 text-xs text-[#F58220] font-semibold">
          <Gift size={14} /> {c.scholarship} · ROI {c.roi}
        </div>

        <div className="mt-5 flex items-center gap-2">
          <button onClick={enquire} className="flex-1 inline-flex items-center justify-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold py-3 rounded-lg transition-colors">
            Check Eligibility <ArrowRight size={16} />
          </button>
          <button
            onClick={() => toggle(c)}
            title={selected ? "Remove from compare" : "Add to compare"}
            className={`w-11 h-11 shrink-0 rounded-lg border-2 flex items-center justify-center transition-colors ${
              selected ? "border-[#16244F] bg-[#16244F] text-white" : "border-gray-200 text-[#16244F] hover:border-[#16244F]"
            }`}
          >
            {selected ? <Check size={18} /> : <GitCompare size={18} />}
          </button>
        </div>
      </div>
    </article>
  );
}
